module.exports = __webpack_public_path__ + "static/al-f349f67721ec33a235390e9115ddf7da.png";